'use strict';
import get from 'lodash/get';
import isObject from 'lodash/isObject';
import noop from 'lodash/noop';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {ListItem} from '../../../components/lists/ListItem';
import {Button} from '../../../components/buttons/Button';
import {I18nComponent} from '../../../core-utilities/react-i18n';
import {StatelessStatusSelector} from '../../../core-components/selectors/components/StatelessStatusSelector';
import {ASSET_PROJECT_COLLECTION} from '../../domain/config';
import {PROJECT_COLLECTION} from '../../domain/ProjectDomain';
import {SvgIcon} from '../../../core-components/svg-menu-icons/SvgIcon';
import {SvgIcons} from '../../../core-components/svg-menu-icons/icons';


export function AssetProjectCardView(props) {
  const model = props.model;
  const name = get(model, 'project.name');
  const description = get(model, 'project.description');

  return (
    <ListItem
      className={classNames("AssetProjectCard", props.className)}
      bindParam={model}
      onClick={props.onClick}
    >
      <div className="AssetProjectCard__nameWrapper">
        <span className="AssetProjectCard__name">
          {name}
        </span>
      </div>
      <span className="AssetProjectCard__description">
        {description}
      </span>
      <div className="AssetProjectCard__content">
        <StatelessStatusSelector
          className="AssetProjectCard__status"
          labelClassName="AssetProjectCard__status__label"
          model={model}
          readOnly={true}
          hideValue={false}

          status={model.status}
          collection={ASSET_PROJECT_COLLECTION}
        />
        <span className="AssetProjectCard__assetIcon">
          <i className="icon ion-ios-folder-outline" />
        </span>
        <span className="AssetProjectCard__assetCount">
          {getFileRequirementMetrics(model.metrics)}
        </span>
      </div>
      <div className="AssetProjectCard__dataTags">
        {model.tags && model.tags.map(tag => `#${tag}`).join(', ')}
      </div>
    </ListItem>
  );
}

AssetProjectCardView.propTypes = {
  className: T.string,
  model: T.object.isRequired,

  assetCountLabel: T.string,

  onClick: T.func.isRequired,
};

export function getFileRequirementMetrics(metrics) {
  if (!isObject(metrics)) {
    return '-';
  } else {
    const total = metrics.reqCount - metrics.reqCancelled;
    const current = metrics.reqSubmitted + metrics.reqApproved;

    return !total ? '-' : `${current}/${total}`;
  }
}



// WEBPACK FOOTER //
// ./src/js/projects/components/AssetProjectCard/AssetProjectCardView.js